<template>
    <sui-form @submit="onSubmit">
        <sui-form-field>
            <sui-dropdown
                multiple
                fluid
                :options="customersOptions"
                :placeholder="$t('common.customers')"
                search
                v-model="activeCustomerGateway.sharedWithIds"
                selection
            />
        </sui-form-field>
    </sui-form>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';

export default {
    name: 'ShareCustomerGatewayFileForm',
    props: {
        onSubmit: Function,
        selectedFileId: Number,
        customers: Array,
    },
    watch: {
        selectedFileId: async function(current, previous) {
            if (current !== previous && current) {
                await store.dispatch('getCustomerGatewayById', {
                    customerId: this.currentCustomerId,
                    gatewayFileId: this.selectedFileId,
                });
            }
        }
    },
    computed: {
        ...mapGetters(['activeCustomerGateway']),
        currentCustomerId: {
            get() {
                return this.$route.params.customer_id;
            }
        },
        customersOptions: {
            get() {
                return this.customers.filter(c => c.value !== +this.currentCustomerId);
            }
        }
    }
}
</script>